<template>
  <div
    v-if="timeFrom"
    class="flow-block flow-block-commitment"
    :style="{ height: height }" ref="flow_block">

    <div v-if="SHOW_DEBUG && false">
      <pre class="mini-pre">{{draggablesListVirtualOffsets}}</pre>
      <pre class="mini-pre">drag_item_placement: {{drag_item_placement}}</pre>
      <pre class="mini-pre">drag_target_space: {{drag_target_space}}</pre>
    </div>

    <div class="flow-time-drag flow-time-drag--start flow-time-drag--ghost" :style="{ backgroundColor: bgColor, ...styleDragHandle}"></div>
    <!--dragTimeActive: {{ dragTimeActive }}
    drag_time_selection: {{ drag_time_selection }}-->
    <div v-if="!show_reduced_dayplan"
      @mousedown="onBgDragMouseDown('from', $event)"
      :class="{
        'flow-time-drag flow-time-drag--start': true,
        'flow-time-locked': item.fixedFrom,
        'flow-time-unlocked': !item.fixedFrom,
      }"
      :style="{ backgroundColor: bgColor }">
      <!-- {{timeFrom * 1e3|shortTime}} -->
      <!-- TODO: Should be same format as to time -->
      <!--<TimeSelector
        size="mini"
        :value="timeFromDisplay"
        placeholder="Start time"
        :timePickerOptions = "{
          start: '00:00',
          step:  '00:15',
          end:   '24:00'
        }"
        color="#ffffff"
        style="margin-right: 6px;"
        @save="onSaveTime($event)" />-->
      <span style="margin-right: 6px">{{timeFrom * 1e3|shortTime}}</span>

      <span
        @mousedown.prevent.stop="onLockTime('from')"
        class="flow-time-btn"
        :title="time_to_locked ? 'Click to unlock time' : 'Click to lock time'" />

      <span v-if="dragTimeActive">
        {{ (this.timeFrom - this.item.from) >= 0 ? '+' : '' }}&nbsp;
        {{ (this.timeFrom - this.item.from)|hoursMinutes }}
      </span>
    </div>

    <div class="flow-time-drag flow-time-drag--end flow-time-drag--ghost" :style="{ backgroundColor: bgColor, ...styleDragHandle}"></div>

    <!-- TOOD: remove copy / paste -->
    <div v-if="!show_reduced_dayplan"
      @mousedown="onBgDragMouseDown('to', $event)"
      :class="{
        'flow-time-drag flow-time-drag--end': true,
        'flow-time-locked': item.fixedTo,
        'flow-time-unlocked': !item.fixedTo,
      }"
      :style="{ backgroundColor: bgColor }">

      <span style="margin-right: 6px">{{timeTo * 1e3|shortTime}}</span>
      <span
        @mousedown.prevent.stop="onLockTime('to')"
        class="flow-time-btn"
        :title="time_from_locked ? 'Click to unlock time' : 'Click to lock time'" />
      <span v-if="dragTimeActive">
        {{ (this.timeTo - this.item.to) >= 0 ? '+' : '' }}&nbsp;
        {{ (this.timeTo - this.item.to)|hoursMinutes }}
      </span>
    </div>

    <!--
    <div class="flow-time-spacer" v-if="y_drag_active === 'to' && widthDuringShortening != 0">
      <div
        class="flow-time-spacer__bar"
        :style="{ width: ( widthDuringShortening > 0 ? widthDuringShortening : 0 ) + 'px' }">
      </div>
      <div v-if="y_drag_active === 'from'">
        <div v-if="widthDuringShortening > 0">
          Shortening event by {{(this.item.from - this.timeFrom)|hoursMinutes}}
        </div>
        <div v-else>
          Extending event by {{(this.timeFrom - this.item.from)|hoursMinutes}}
        </div>
      </div>
      <div v-if="y_drag_active === 'to'">
        <div v-if="widthDuringShortening > 0">
          Shortening event by {{(this.item.to - this.timeTo)|hoursMinutes}}
        </div>
        <div v-else>
          Extending event by {{(this.timeTo - this.item.to)|hoursMinutes}}
        </div>
      </div>
    </div>
    -->

    <div class="flow-block-header p-2">
      <font-awesome-icon
        v-if="showRemove && !show_reduced_dayplan"
        size="2x"
        :icon="['fas', 'times']"
        class="inline-icon"
        style="
          cursor: pointer;
          float: right;
          width: 22px;
          height: 22px;
          display: block;
          padding: 3px;"
        @click="onRemove" />

      <template v-if="SHOW_DEBUG">
        <pre class="mini-pre">FROM: {{item.from * 1e3|shortTime}}<br />TO:   {{item.to ? $options.filters.shortTime( item.to * 1e3 ) : 'null'}}</pre>
        <pre class="mini-pre">item: {{item}}</pre>
      </template>

      <!-- <slot name="header"></slot> -->
      <slot></slot>
    </div>
    <!--
    <pre class="mini-pre">
y_drag_offset: {{y_drag_offset}}
y_drag_offset_init: {{y_drag_offset_init}}
y_drag_box_height: {{y_drag_box_height}}
y_drag_active: {{y_drag_active}}
    </pre>
    -->
    <div class="flow-block-controls text-right"></div>
    <div v-if="showConnection" class="flow-block-string position-absolute"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
//import TimeSelector from "@/components/Elements/TimeSelectorInline";
import moment from '@/moment-gp';

export default {
  props: {
    item: {},
    showConnection: { default: true },
    showRemove: { default: true },
    draggablesListVirtualOffsets: { // TODO: vuex
      type: Object
    },
    dragTimeActive: { // TODO: vuex
      type: Boolean
    },
  },
  data() {
    return {
      y_drag_offset: 0,
      y_drag_offset_init: 0,
      y_drag_active: false,
      y_drag_box_height: 0,
      time_from_locked: false,
      time_to_locked: false,
    }
  },
  /*watch: {
    dragTimeActive(val) {
      console.log('watcher', val)
    }
  },*/
  computed: {
    ...mapGetters("dayplanner", [
      "show_reduced_dayplan",
      'drag_item_placement',
      'drag_target_space',
      'drag_time_selection',
      'dayplan_virtual_offsets'
    ]),
    bgColor() {
      if (this.item && this.item.config && this.item.config.tscColor) {
        return this.item.config.tscColor //'#cd201f'
      } else {
        return '#cd201f'
      }
    },
    height() {
      return 'unset'
    },
    styleDragHandle() {
      return {}
    },
    virtualOffsetCurrentSession() {
      if (this.dayplan_virtual_offsets && this.dayplan_virtual_offsets[ this.item.sessionId ]) {
        return this.dayplan_virtual_offsets[ this.item.sessionId ]
      } else {
        return {
          from: 0,
          to: 0
        }
      }
    },
    timeFrom: {
      get() {
        return this.item.from + this.virtualOffsetCurrentSession.from
      },
      set(value) {
      }
    },
    timeFromDisplay: {
      get() {
        return moment.unix(this.item.from).format("HH:mm");
      }
    },
    timeTo: {
      get() {
        return this.item.to + this.virtualOffsetCurrentSession.to
      },
      set(value) {
        console.error("not supported");
      }
    },
  },
  methods: {
    ...mapActions('dayplanner', [
      'setDragTimeActive'
    ]),
    onRemove() {
      this.$emit("remove");
    },
    onBgDragMove(e) {
      // TODO: Limit to start time + 5 min
      this.y_drag_offset = e.clientY - this.y_drag_offset_init;
      const f = 0.2; // Scale factor
      const steps = 5 * 60 // 5 Minute steps
      let offset = steps * f * this.y_drag_offset;

      this.$emit('drag-time', { selection: this.y_drag_active, offset: offset })
      // Snap to grid: this.y_drag_offset = Math.round( this.y_drag_offset / 10 ) * 10;
    },
    onBgDragMouseDown(source, $event) {
      console.log('onBgDragMouseDown', source)
      $event.preventDefault();
      this.y_drag_offset_init = $event.clientY + 0;
      this.y_drag_active = source;
      window.addEventListener('mouseup', this.onBgDragMouseUp, false);
      window.addEventListener('pointerup', this.onBgDragMouseUp, false);
      window.addEventListener('mousemove', this.onBgDragMove, true);

      let rect = this.$refs.flow_block.getClientRects();
      this.y_drag_box_height = rect[0].height;
      document.body.style.cursor = 'ns-resize';
      //this.$emit('drag-time-active',  { value: true })
      this.setDragTimeActive(true)
    },
    onBgDragMouseUp(source, $event) {
      window.removeEventListener('mouseup', this.onBgDragMouseUp, false);
      window.removeEventListener('pointerup', this.onBgDragMouseUp, false);
      window.removeEventListener('mousemove', this.onBgDragMove, true);
      if (this.timeFrom !== this.item.from || this.timeTo !== this.item.to) {
        this.$emit('change-time', { selection: 'time', timeFrom: this.timeFrom, timeTo: this.timeTo })
      }
      this.y_drag_active = false;
      this.y_drag_offset_init = 0;
      // this.y_drag_offset = 0;
      document.body.style.cursor = 'default';
      console.log('onBgDragMouseUp')
      this.setDragTimeActive(false)
      //this.$emit('drag-time-active', { value: false })
    },
    onLockTime(selection) {
      if ( selection === 'from' ) {
        console.log("LOCK from")
        // this.time_from_locked = !this.time_from_locked;
        this.$emit('lock-time', { selection, value: !this.item.fixedFrom })
      }
      if ( selection === 'to' ) {
        console.log("LOCK to")
        // this.time_to_locked = !this.time_to_locked;
        this.$emit('lock-time', { selection, value: !this.item.fixedTo })
      }
    }
  },
  components: {
    //TimeSelector
  }
};
</script>

<style>
/*
ALTERNATIV 1:

.flow-time-drag {
  font-size: 8pt;
  color: white;
  width: 45px;
  position: absolute;
  transform: translateX(-45px);
  text-align: center;
  border-radius: 3px 0 0 3px;
  font-weight: bold;
  z-index: -1;
}
.flow-time-drag--start {
  top: 5px;
}
.flow-time-drag--end {
  bottom: 5px;
}
*/

/* ALTERNATIVE 2: */
.flow-time-drag {
  font-size: 9pt;
  color: white;
  width: 130px;
  height: 19px;
  position: absolute;
  text-align: center;
  font-weight: bold;
  z-index: -1;
  display: flex;
  /*box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);*/
  line-height: 18px;
}
.flow-time-drag--start {
  border-radius: 3px 3px 0 0;
  transform: translateY(-20px);
  /*left: 5px;*/
  left: -1px;
  cursor: ns-resize;
  justify-content: flex-start;
  padding-left: 0.5em
}
.flow-time-drag--end {
  border-radius: 0 0 3px 3px;
  transform: translateY(+20px);
  bottom: 0;
  /*right: 5px;*/
  right: -1px;
  cursor: ns-resize;
  justify-content: flex-end;
  padding-left: 0.2em;
  padding-right: 0.2em
}
.flow-time-drag--ghost {
  display: none;
}
.flow-time-spacer {
  /* border-radius: 5px 5px 0 0; */
  height: 30px;
  width: 100%;
  position: absolute;
  background: #bbb;
  font-weight: bold;
  color: white;
  z-index: 99;
  /* bottom */
  border-radius: 0 0 3px 3px;
  bottom: 0;
}
.flow-time-spacer > div {
  border-radius: 5px 0 0 0;
  position: absolute;
  line-height: 30px;
  height: 30px;
  width: 100%;
  text-align: center;
}
.flow-time-spacer__bar {
  background: var(--red);
}

.flow-time-btn {
  border-radius: 50%;
  font-size: 10px;
  cursor: pointer;
  background-color: none;
}
.flow-time-btn::before {
  /* margin-left: 1px; */
}
.flow-time-locked {
  /*border: 2px solid black;
  padding: 0;*/
}
.flow-time-unlocked .flow-time-btn::before {
  content: "\0021C5";
  /*content: "\01F513";*/
  filter: grayscale(1);
  /*opacity: 0.2;*/
  font-size: 15px;
  padding: "2px"
}
.flow-time-unlocked:hover .flow-time-btn::before {
  content: "\01F512";
  font-size: 12px
}
.flow-time-locked .flow-time-btn::before {
  content: "\01F512";
  filter: grayscale(0);
  opacity: 1;
  font-size: 12px
}
.flow-time-locked:hover .flow-time-btn::before {
  /*content: "\01F513";*/
  content: "\0021C5";
  font-size: 15px
}
</style>
